// BrandWheel — the canonical, on-brand iYuga Wheel React component.
// WL-001 (Fable Hail Mary). Wraps the framework-free renderer in ./brandWheel.js
// so every screen renders a decorative/placeholder Wheel through ONE shared
// component (design-conformance gate G-19; "everything is a shared component").
//
// Use this instead of hand-rolling any segmented ring / donut / conic-gradient
// wheel. For an app-data-driven interactive Wheel keep using the existing
// CustomWheel/D3Wheels; BrandWheel is the on-brand placeholder/decorative/icon
// renderer (loaders, empty states, avatars, marketing, pickers, favicons).
//
// Examples:
//   <BrandWheel size={96} />                              // colored, white disc
//   <BrandWheel size={24} lineArt />                      // line-art icon
//   <BrandWheel size={120} ariaLabel="iYuga Wheel" />     // meaningful (role=img)
//   <BrandWheel size={80} portrait={'<image .../>'} />    // custom center content

import React from "react";
import { brandWheelInner } from "./brandWheel";

export {
  brandWheelSVG,
  brandWheelInner,
  BRAND_WHEEL_COLORS,
  BRAND_WHEEL_PALETTE,
  BRAND_WHEEL_SPANS,
} from "./brandWheel";

const BrandWheel = ({
  size = 96,
  spans,
  colors,
  ratio,
  gap,
  lineArt = false,
  stroke,
  strokeWidth,
  disc,
  portrait = "",
  ariaLabel = "",
  className,
  style,
  ...rest
}) => {
  const inner = brandWheelInner({
    spans,
    colors,
    ratio,
    gap,
    lineArt,
    stroke,
    strokeWidth,
    disc,
    portrait,
  });

  const ariaProps = ariaLabel
    ? { role: "img", "aria-label": ariaLabel }
    : { "aria-hidden": "true" };

  return (
    <svg
      {...ariaProps}
      width={size}
      height={size}
      viewBox="0 0 120 120"
      className={className}
      style={{ display: "block", flex: "0 0 auto", ...style }}
      dangerouslySetInnerHTML={{ __html: inner }}
      {...rest}
    />
  );
};

export default BrandWheel;
